package com.essntl.features.itinerary.ui.all_itinerary

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.itinerary.domain.model.ItineraryOrderType
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllItineraryViewModel(
    private val itineraryRepository: ItineraryRepository,
    private val areaRepository: AreaRepository,
    private val profileRepository: ProfileRepository,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
    private val state: MutableStateFlow<AllItineraryState>,
) : ViewModel {

    init {
        getArea()
        getAllProfile()
    }

    fun onEvent(event: AllItineraryEvent) {
        when (event) {
            is AllItineraryEvent.LoadAllItinerary -> loadAllItinerary()
            is AllItineraryEvent.FilterItinerary -> filterItinerary(event)
            is AllItineraryEvent.SelectItinerary -> selectItinerary(event)
            is AllItineraryEvent.EditClient -> editClient(event)
        }
    }

    private fun getAllProfile() =
        getData(
            getData = { profileRepository.getAll() },
            getState = { state.value.getAllProfile },
            setState = { newState -> state.update { it.copy(getAllProfile = newState) } },
        )

    private fun loadAllItinerary() =
        getData(
            getData = { itineraryRepository.getAll() },
            getState = { state.value.getAllItinerary },
            setState = { newState ->
                state.update {
                    it.copy(
                        getAllItinerary = newState,
                    )
                }
            },
        )

    private fun getArea() =
        getData(
            getData = { areaRepository.getAll() },
            getState = { state.value.getAllArea },
            setState = { newState -> state.update { it.copy(getAllArea = newState) } },
        )

    private fun filterItinerary(event: AllItineraryEvent.FilterItinerary) {
        state.update {
            it.copy(
                filterOptions = event.filterOptions,
            )
        }
    }

    private fun selectItinerary(event: AllItineraryEvent.SelectItinerary) {
        state.update {
            it.copy(
                selectedItineraryId = event.itineraryId,
            )
        }
    }

    private fun editClient(event: AllItineraryEvent.EditClient) {
        state.update {
            it.copy(
                getAllItinerary = state.value.getAllItinerary.copy(
                    data = state.value.getAllItinerary.data
                        .orEmpty()
                        .map { i ->
                            if (i.id == event.itinerary.id)
                                i.copy(proposal = i.proposal?.copy(primaryClient = event.client)) else
                                i
                        },
                ),
            )
        }
    }
}